import React from 'react';
import { Divider } from 'antd';
import { Button } from '@progress/kendo-react-buttons';
import { clearSubmitNewOrder } from 'store/modules/order';
import { useDispatch } from 'react-redux';

export default function OrderCompleted(props) {
  const dispatch = useDispatch();
  const backToForm = () => {
    dispatch(clearSubmitNewOrder());
    props.onModeChange('form');
    props.isUpdateMode('cancel');
  };

  return (
    <div className="orderCompleted-container" style={{ textAlign: 'center' }}>
      <h2 style={{ marginLeft: '20px', marginTop: '10px' }}>
        Hedge Order Complete
      </h2>
      <Divider style={{ margin: '10px 0px' }} />

      <div style={{ marginLeft: '20px', marginTop: '20px' }}>
        Your hedge order has been completed
      </div>
      <Button
        onClick={backToForm}
        style={{
          backgroundColor: 'green',
          color: 'white',
          marginLeft: '20px',
          marginTop: '20px',
        }}
      >
        Submit Another Order
      </Button>
    </div>
  );
}
